import React from 'react'
import { Link, useNavigate } from 'react-router-dom'
import { Facebook, Instagram, MapPin, Phone, Mail } from 'lucide-react'
import { useScrollToTop } from './ScrollTop'

const Footer = () => {
  const navigate = useNavigate()
  useScrollToTop() // Use the scroll hook

  const handleNavigation = (path) => {
    navigate(path)
  }

  return (
    <footer className="bg-gray-900 text-gray-300 py-8 sm:py-12 lg:py-16">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12 mb-8 lg:mb-12">
          {/* About Section */}
          <div className="space-y-4">
            <h2 className="text-lg sm:text-xl font-semibold text-white">
              About Royal Rise
            </h2>
            <p className="text-sm sm:text-base">
              At Royal Rise Tours & Travels, we specialize in providing safe,
              reliable, and cost-effective employee transportation solutions.
              With over 15 years of industry expertise, we are committed to
              delivering excellence in corporate transportation services.
            </p>
            <div className="flex space-x-6 pt-2">
              <Link
                to="/"
                className="hover:text-blue-600 transition-colors duration-300"
              >
                <Facebook className="w-5 h-5 sm:w-6 sm:h-6" />
              </Link>
              <Link
                to="/"
                className="hover:text-pink-600 transition-colors duration-300"
              >
                <Instagram className="w-5 h-5 sm:w-6 sm:h-6" />
              </Link>
            </div>
          </div>

          {/* Information Section */}
          <div className="space-y-4">
            <h2 className="text-lg sm:text-xl font-semibold text-white">
              Information
            </h2>
            <ul className="space-y-2 text-sm sm:text-base">
              {[
                { name: 'About Us', path: '/aboutus' },
                { name: 'Services', path: '/service' },
                { name: 'Why Choose Us', path: '/why-choose-us' },
                { name: 'Rental Packages', path: '/rental-packages' },
              ].map((item, idx) => (
                <li key={idx}>
                  <Link
                    to={item.path}
                    onClick={() => handleNavigation(item.path)}
                    className="hover:text-white transition-colors duration-300 block py-1"
                  >
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Customer Support Section */}
          <div className="space-y-4">
            <h2 className="text-lg sm:text-xl font-semibold text-white">
              Customer Support
            </h2>
            <ul className="space-y-2 text-sm sm:text-base">
              <li>
                <Link
                  to="/contact"
                  onClick={() => handleNavigation('/contact')}
                  className="hover:text-white transition-colors duration-300 block py-1"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Section */}
          <div className="space-y-4">
            <h2 className="text-lg sm:text-xl font-semibold text-white">
              Have a Question?
            </h2>
            <ul className="space-y-4 text-sm sm:text-base">
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0 mt-1" />
                <span className="break-words">
                  No.20, 2ND CROSS, ROYAL MERIDIEN LAYOUT, DEVARCHIKKANAHALLI,
                  BEGUR ROAD, Bangalore - 560076 Karnataka
                </span>
              </li>
              <li>
                <a
                  href="tel:+918548023977"
                  className="flex items-center space-x-3 hover:text-white transition-colors duration-300"
                >
                  <Phone className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" />
                  <span>+91 8884903332</span>
                  <span>+91 8884903331</span>
                </a>
              </li>
              <li>
                <a
                  href="mailto:royalrisetours@gmail.com"
                  className="flex items-center space-x-3 hover:text-white transition-colors duration-300"
                >
                  <Mail className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0" />
                  <span className="break-all">info@royalrisetours.com</span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
